module.exports = __webpack_public_path__ + "img/settings-2.1a7befc7.png";